import fonts from './fonts'


const textStyles = {
  titleH1: {
    ...fonts.BbCondBold,
    fontSize: '4.6rem',
    lineHeight: '1.2',
    letterSpacing: '-0.5px',
  },
  titleH1Mobile: {
    ...fonts.BbCondBold,
    fontSize: '2.8rem',
    lineHeight: '1.2',
    letterSpacing: '-0.5px',
  },
  titleH2: {
    ...fonts.BbCondBold,
    fontSize: '3.4rem',
    lineHeight: '1.2',
    letterSpacing: '-0.5px',
  },
  titleH2Mobile: {
    ...fonts.BbCondBold,
    fontSize: '2.2rem',
    lineHeight: '1.2',
    letterSpacing: '-0.5px',
  },
  titleH3: {
    ...fonts.BbCondBold,
    fontSize: '2.6rem',
    lineHeight: '1.2',
    letterSpacing: '-0.5px',
  },
  titleH3Mobile: {
    ...fonts.BbCondBold,
    fontSize: '2.3rem',
    lineHeight: '1.2',
    letterSpacing: '-0.5px',
  },
  textRegular: {
    ...fonts.BbRegular,
    fontSize: '1.8rem',
    lineHeight: '1.2',
    letterSpacing: '-0.5px',
  },
  textRegularMobile: {
    ...fonts.BbRegular,
    fontSize: '1.4rem',
    lineHeight: '1.2',
    letterSpacing: '-0.5px',
  },
  gameTitle: {
    ...fonts.BbCondBold,
    fontSize: '3.8rem',
    lineHeight: '4rem',
    letterSpacing: '-0.5px',
  },
  gameTitleMobile: {
    ...fonts.BbCondBold,
    fontSize: '2.7rem',
    lineHeight: '3rem',
    letterSpacing: '-0.5px',
  },
  downloadGame: {
    ...fonts.BbCondBold,
    fontSize: '2rem',
    lineHeight: '1.2',
    letterSpacing: '-0.5px',
  },
  downloadGameMobile: {
    ...fonts.BbCondBold,
    fontSize: '1.6rem',
    lineHeight: '1.2',
    letterSpacing: '-0.5px',
  },
  fileSize: {
    ...fonts.BbCond,
    fontSize: '1.6rem',
    lineHeight: '1.2',
    letterSpacing: '-0.5px',
  },
  fileSizeMobile: {
    ...fonts.BbCond,
    fontSize: '1.4rem',
    lineHeight: '1.2',
    letterSpacing: '-0.5px',
  },
  stickKey: {
    ...fonts.BbRegular,
    fontSize: '2rem',
    lineHeight: '1.2',
    letterSpacing: '-0.5px',
  },
  keyboardKey: {
    ...fonts.BbRegular,
    fontSize: '2rem',
    lineHeight: '1.2',
    letterSpacing: '-0.5px',
  },
  tutorialText: {
    ...fonts.BbRegular,
    fontSize: '1.2rem',
    lineHeight: '1.2',
    letterSpacing: '-0.5px',
  },
  carouselCurrentLookText: {
    ...fonts.BbCondBold,
    fontSize: '1.6rem',
    lineHeight: '1.2',
    letterSpacing: '-0.5px',
  },
  carouselCurrentLookTextMobile: {
    ...fonts.BbCondBold,
    fontSize: '1.2rem',
    lineHeight: '1.2',
    letterSpacing: '-0.5px',
  },
  queueNumber: {
    ...fonts.BbRegular,
    fontSize: '4rem',
    lineHeight: '1.2',
    letterSpacing: '-0.5px',
  },
  queueNumberMobile: {
    ...fonts.BbRegular,
    fontSize: '2rem',
    lineHeight: '1.2',
    letterSpacing: '-0.5px',
  },
}

export default textStyles
